import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const v = () => /* @__PURE__ */ s.jsxs("svg", { viewBox: "0 0 75 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ s.jsx("path", { d: "M55 40c11.046 0 20-8.954 20-20S66.046 0 55 0 35 8.954 35 20s8.954 20 20 20", fill: "#26A17B" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M57.404 21.728v-.002c-.138.01-.847.052-2.428.052-1.262 0-2.151-.037-2.464-.052v.004c-4.86-.214-8.487-1.06-8.487-2.073s3.627-1.857 8.487-2.075v3.305c.318.023 1.228.076 2.485.076 1.509 0 2.265-.062 2.407-.075v-3.303c4.85.216 8.468 1.062 8.468 2.072 0 1.013-3.618 1.856-8.468 2.071m0-4.487v-2.958h6.767v-4.51H45.745v4.51h6.767v2.957c-5.5.252-9.636 1.342-9.636 2.647s4.136 2.394 9.636 2.648v9.477h4.892v-9.48c5.49-.252 9.617-1.341 9.617-2.645s-4.126-2.392-9.617-2.646",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20", fill: "#8F8FEF" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "m20.41 3.167-.024.04L24.549 24.5l10.337 3.75zm-.937.666L5 28.917h.012l16.53-14.479zM34.97 29.208l-20.461-7.416-8.498 7.416z",
      fill: "#fff"
    }
  )
] });
export {
  v as U
};
